import CaseFirstViewWhite from 'components/cases/common/CasesFirstViewWhite/'
import OverView from 'components/cases/common/Overview/'
import MobileAppDevelopment from 'components/services/common/MobileAppDevelopment'
import Interview from 'components/cases/sanu/Interview/Interview'
import CaseStudyNew from '../../home/CaseStudy/CaseStudyNew'
import {
  firstViewItemWhite,
  overviewItem,
  overviewTitle,
  issueSolutionItems,
  caseCTAItem,
  caseDownloadCTAItem,
} from './sanuItems'
import styles from './sanu.module.scss'
import CaseCTA from 'components/cases/common/CaseCTA'
import CaseDownloadCTA from 'components/cases/common/CaseDownloadCTA'
import FooterCTA from 'components/common/FooterCTA'

const Sanu = (): JSX.Element => {
  return (
    <>
      <CaseFirstViewWhite firstViewItemWhite={firstViewItemWhite} />
      <OverView overviewItem={overviewItem} issueSolutionItems={issueSolutionItems} overviewTitle={overviewTitle} />
      <Interview />
      <CaseCTA {...caseCTAItem} />
      <CaseDownloadCTA {...caseDownloadCTAItem} />
      <FooterCTA />
      <div className={styles.mobileAppWrapper}>
        <MobileAppDevelopment />
      </div>
      <div className={styles.line}>
        <CaseStudyNew />
      </div>
    </>
  )
}

export default Sanu
